import React from 'react';
import { TextField, TextFieldProps } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';

import { useGetTestRailApiProjects } from '../TestRail.hooks';
import { TestRailApiProject } from '../TestRail.interface';

export interface TestRailApiProjectPickerProps {
  project: TestRailApiProject | null | undefined;
  disabled?: boolean;
  className?: string;
  textFieldProps?: TextFieldProps;
  onChange?: (project: TestRailApiProject | null) => void;
}

const TestRailApiProjectPicker: React.FC<
  TestRailApiProjectPickerProps
> = props => {
  const { project, disabled, className, textFieldProps, onChange } = props;
  const {
    projectList,
    isLoading: isFindingProjects,
    error: getProjectError,
    getProjects,
    setState: setProjectState
  } = useGetTestRailApiProjects();
  const classes: string[] = [];
  className && classes.push(className);

  return (
    <Autocomplete
      fullWidth
      disabled={disabled}
      loading={isFindingProjects}
      value={project || null}
      options={projectList?.projects || []}
      className={classes.join(' ')}
      // project prefix: P123
      getOptionLabel={project => `P${project.id}: ${project.name}`}
      getOptionSelected={(option, value) => option.id === value.id}
      onOpen={() => {
        // initial fetch on open
        if (
          (!projectList || projectList.projects.length === 0) &&
          !isFindingProjects
        ) {
          getProjects();
        }
      }}
      onInputChange={() => {
        // clear any errors when input changes
        setProjectState(state => ({ ...state, error: undefined }));
      }}
      onChange={(_, value) => {
        // clear any errors when selection changes
        setProjectState(state => ({ ...state, error: undefined }));

        onChange?.(value);
      }}
      renderInput={params => (
        <TextField
          {...params}
          fullWidth
          variant='outlined'
          label='Project'
          placeholder='Select TestRail Project'
          {...textFieldProps}
          error={!!getProjectError || textFieldProps?.error}
          helperText={getProjectError?.message || textFieldProps?.helperText}
        />
      )}
    />
  );
};

export default TestRailApiProjectPicker;
